import React from 'react';

import '../Tutorial.css';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";

function T84BossWindowSecond() {


    const text = 'Lesson three — the exam. You’re my best student, so I believe you’ll do great.'
    return (
        <div>

            <div className={'BossWindow30Top'}></div>

            <div className={'BossWindow30Left'}></div>

            <TutorialGirl undressingProcess={3}/>
            <div className='tutorialContainer tutorialTopContainer84'>
                <div className='tutorialBottomTextField'><Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start();
                    }}
                /></div>
            </div>
        </div>

    );
}

export default T84BossWindowSecond;
